/** Default sort matches the server's own default (`updated_at DESC`) so the
 *  no-param and explicit-param requests return identical pages. */
export const ORDERS_HUB_DEFAULT_SORT = 'updatedAt:DESC';

export interface OrdersHubListParams {
  /** 1-based page (useTable convention). */
  page: number;
  count: number;
  sort?: string;
}

/** Build the `GET /orders` query string. The API is 0-based on `page`. */
export function buildOrdersHubQs(params: OrdersHubListParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(params.count));
  qs.set('sort', params.sort ?? ORDERS_HUB_DEFAULT_SORT);
  qs.set('isArchived', 'false');
  return qs.toString();
}

/** Build the `GET /order-lines` query string for one order. `count` is capped
 *  at 100 by the API — the line count still comes from `meta.totalCount`, but
 *  sub-rows beyond 100 are truncated (documented limit). */
export function buildOrderLinesQs(orderId: string): string {
  const qs = new URLSearchParams();
  qs.set('orderId', orderId);
  qs.set('page', '0');
  qs.set('count', '100');
  return qs.toString();
}

export interface OrderLinesListParams {
  /** 1-based page (useTable convention). */
  page: number;
  count: number;
}

/** Build the `GET /order-lines` query string for the standalone all-lines list
 *  (no `orderId` → every line the company owns). The API is 0-based on `page`
 *  and caps `count` at 100; it exposes no sort param. */
export function buildAllOrderLinesQs(params: OrderLinesListParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(Math.min(100, params.count)));
  return qs.toString();
}
